import { aboutData } from '@/mocks/about';

export default function AboutBrand() {
  return (
    <section className="bg-background-200/50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          {/* Text Content */}
          <div className="lg:col-span-7 lg:col-start-2">
            <span className="text-xs font-bold text-foreground-400 uppercase tracking-wider">
              品牌介绍
            </span>
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mt-3 leading-tight">
              {aboutData.tagline}
            </h1>
            <div className="mt-8 space-y-5">
              {aboutData.description.split('\n\n').map((paragraph, idx) => (
                <p
                  key={idx}
                  className="text-sm md:text-base text-foreground-600 leading-relaxed"
                >
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Stats */}
            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {aboutData.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 rounded-2xl p-4 text-center"
                >
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-400 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Images */}
          <div className="lg:col-span-3 lg:col-start-9">
            <div className="space-y-4">
              <div className="w-full h-48 rounded-2xl overflow-hidden">
                <img
                  src={aboutData.images[0].url}
                  alt={aboutData.images[0].alt}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-full h-64 rounded-2xl overflow-hidden">
                <img
                  src={aboutData.images[1].url}
                  alt={aboutData.images[1].alt}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}